import {
  FaBell,
  FaUserCheck,
  FaFile,
  FaCheckCircle,
  FaExclamationCircle,
} from "react-icons/fa";
import { useNotifications } from "../../StateManagement/notificationContext";

const NotificationPanel = () => {
  const { notifications } = useNotifications();

  const getIcon = (type: string) => {
    switch (type) {
      case "loan":
        return <FaFile className="w-5 h-5 text-blue-600" />;
      case "user":
        return <FaUserCheck className="w-5 h-5 text-green-600" />;
      case "success":
        return <FaCheckCircle className="w-5 h-5 text-emerald-500" />;
      case "error":
        return <FaExclamationCircle className="w-5 h-5 text-red-500" />;
      default:
        return <FaBell className="w-5 h-5 text-gray-500" />;
    }
  };

  const getBadgeColor = (type: string) => {
    switch (type) {
      case "loan":
        return "bg-blue-100 text-blue-600";
      case "user":
        return "bg-green-100 text-green-600";
      case "success":
        return "bg-emerald-100 text-emerald-600";
      case "error":
        return "bg-red-100 text-red-600";
      default:
        return "bg-gray-100 text-gray-600";
    }
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-xl shadow-lg p-5 max-h-96 overflow-y-auto custom-scrollbar">
      <h3 className="text-xl font-semibold mb-4 text-gray-800 dark:text-white flex items-center gap-2">
        <FaBell className="text-yellow-500" style={{marginRight:4}}/>
        Notifications
      </h3>

      {notifications.length === 0 ? (
        <p className="text-sm text-gray-500 dark:text-gray-400 italic">
          No new notifications available.
        </p>
      ) : (
        <ul className="space-y-3">
          {notifications.map((notif, i) => (
            <li
              key={i}
              className={`flex items-start gap-4 transition-all duration-200 transform hover:scale-[1.01] p-4 rounded-lg ${getBadgeColor(
                notif.type
              )} bg-opacity-40`}
            >
              <div className="pt-1">{getIcon(notif.type)}</div>
              <div className="flex flex-col">
                <span className="text-sm font-medium">
                  {notif.message}
                </span>
                <span className="text-xs text-gray-600 dark:text-gray-400 mt-1">
                  {new Date(notif.timestamp).toLocaleString(undefined, {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                    day: "numeric",
                    month: "short",
                  })}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NotificationPanel;